<template>
  <div id="investor_556" style="position: relative">
    <div class="iconfont icon-fangda" @click="show_chart_dialog = !show_chart_dialog"></div>
    <div style="display: flex; align-items: center; margin-top: 10px">
      <CSelect
        @CSelect_select_val="fnCSelect_chart11"
        :multiple="false"
        :clearable="false"
        mini
        v-bind.sync="select11"
        >选择报告期</CSelect
      >
      <CSelect
        style="margin-left: 10px"
        @CSelect_select_val="fnCSelect_chart1"
        :multiple="false"
        :clearable="false"
        auto
        v-bind.sync="select1"
        >选择资金类型</CSelect
      >
      <div style="display: flex; margin-left: 10px; margin-top: 4px; align-items: center">
        <el-radio v-model="s_radio" label="板块对比">板块对比</el-radio>
        <el-radio v-model="s_radio" label="业态内个券">业态内个券</el-radio>
      </div>
      <CCascader
        v-if="s_radio === '业态内个券'"
        style="margin-left: 10px"
        @CCascader_select_node="fnCCascader_select_val_chart3"
        :default="da_lei_default_value"
        :checkStrictly="true"
        :multiple="true"
        :collapsetags="true"
        :options="category_cascader_options"
        >选择类别
      </CCascader>
      <CCascader
        v-if="s_radio === '业态内个券'"
        style="margin-left: 10px"
        custWidth="250px"
        :checkStrictly="false"
        :multiple="true"
        :isDelete="false"
        :default="reit_code_default"
        placeholder="请选择个股"
        :collapsetags="true"
        @CCascader_select_val="fnSelect_select_val_chart1_codename"
        :options="CODENAMEDATA">
        选择对比REITs
      </CCascader>
      <div style="margin-left: auto; margin-right: 0">
        <Download
          :dButtonsDownloads="dButtonsDownloads"
          :excel_info="excel_info1"
          echartRefName="chart_1716424" />
      </div>
    </div>
    <div style="margin-top: 10px; display: flex; align-items: center">
      <CButtons
        style="margin-left: 0"
        :dButtons1="select_2"
        :dButtons1_current="select_2_default"
        @Cbtns_sep="select2Change" />
      <span class="oneyear">
        <el-checkbox v-model="get_real_holder"></el-checkbox>
        持有者穿透
      </span>
      <el-tooltip class="item" effect="dark" content="" placement="top">
        <div slot="content">
          持有者穿透说明
          <br />
          【指标定义】
          <br />
          根据在CREITS财报中披露的持有人的名字进行一定程度真实持有人的穿
          <br />
          透，但本系统仅可根据公开信息进行穿透，无法对于集合计划/产品中的
          <br />
          每个投资人穿透，只能根据公开信息一定程度局部穿透;其中理财子较
          <br />
          难以穿透，主要由于目前托管行及理财子较难分辨，因此该部分可能存
          <br />
          在错误，请各位投资人谨慎使用;
          <br />
          <br />
          【计算及示例】
          <br />
          举例1:光大证券资管-光大银行-光证资管诚享6号集合资产管理计划,
          <br />
          上述情况中根据部分公开资料了解，光大银行属于真实的持有人，光大
          <br />
          证券资管为受托机构，因此:
          <br />
          选择穿透:持有人-光大银行，类别-银行/银行理财子
          <br />
          不选择穿透:持有人-光大证券资管，类别-券商资管
          <br />
          <br />
          举例2:华金证券-东吴人寿保险股份有限公司-华金证券东吴人寿15号基
          <br />
          础设施基金策略FOF单-资产管理计划
          <br />
          选择穿透:持有人-东吴人寿保险股份有限公司，类别-保险;
          <br />
          不选择穿透:持有人-华金证券，类别-券商资管
        </div>
        <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
      </el-tooltip>
    </div>
    <div class="chart-title">
      {{ '公募REITs - 不同板块细分投资人机构占比' }}
    </div>
    <div
      style="width: 100%; height: 420px; margin-top: 10px"
      ref="chart_1716424"
      v-loading="loading"
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)"></div>
    <div style="margin-top: 30px">
      <el-table
        v-loading="loading"
        element-loading-text="数据量巨大，正在计算中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 1)"
        class="table1"
        :header-cell-style="tableStyle"
        :data="chart_data"
        style="width: 100%">
        <el-table-column prop="index" label="前10大" min-width="94"> </el-table-column>
        <el-table-column
          :formatter="formatterColumn"
          :prop="k"
          :label="k"
          min-width="94"
          sortable
          v-for="k in tabKeys"
          :key="k"
          align="right">
          <template slot-scope="scope">
            {{
              scope.row[k]
                ? select_2_default === '亿元' || select_2_default === '份额'
                  ? numberFix2(scope.row[k] || 0) + '亿'
                  : number2Pct(scope.row[k] || 0)
                : ''
            }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ChartDialog
      :show.sync="show_chart_dialog"
      :echart_options="chart_options"
      :sty1="{ xAxis: { axisLabel: { rotate: 45 } } }"
      :sty2="{ xAxis: { axisLabel: { rotate: 45 } } }"
      :sty3="{ xAxis: { axisLabel: { rotate: 45 } } }" />
  </div>
</template>

<script>
import CCascader from '@/components/Basic/CCascader';
import CSelect from '@/components/Basic/CSelect';
import CButtons from '@/components/Basic/CButtons_separate.vue';
import Download from '@/components/Basic/Download.vue';
import ChartDialog from '../../Basic/ChartDialog.vue';

import { categroyDefaultValue, codesToNameMap2, debounce, number2Pct, numberFix2 } from '@/utils';

import { fnReturnTableStyle } from '@/utils/util';

export default {
  components: { CCascader, CSelect, CButtons, Download, ChartDialog },
  data() {
    const CATEGORYDATA = JSON.parse(localStorage.getItem('CATEGORYDATA')) || [];
    // const da_lei_default_value = categroyDefaultValue(CATEGORYDATA);
    const REITsNAME = JSON.parse(localStorage.getItem('REITsNAME2')) || [];
    const CODEobj = JSON.parse(localStorage.getItem('CODEobj')) || {};
    return {
      CODEobj: Object.freeze(CODEobj),
      chart_options: {},
      show_chart_dialog: false,
      loading: true,
      excel_info1: Object.freeze({
        overviewName: '',
        excel_data: [],
        json_fields: {},
      }),
      dButtonsDownloads: Object.freeze([
        {
          id: '241020',
          name: '下载图片',
        },
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      s_radio: '板块对比',
      da_lei_default_value: [['产权类', '产业园']],
      category_cascader_val_chart3: ['产业园'],
      category_cascader_options: Object.freeze(CATEGORYDATA),
      reit_code_default: [],
      CODENAMEDATA: Object.freeze(REITsNAME),
      reit_code: [],
      select_2: Object.freeze(['亿元', '份额', '绝对', '相对']),
      select_2_default: '亿元',
      select1: {
        default: 'all',
        options: [
          {
            label: '流通及非流通',
            value: 'all',
          },
          {
            label: '流通',
            value: 'float',
          },
          {
            label: '非流通',
            value: 'res',
          },
        ],
      },
      select11: {
        default: '',
        options: [],
      },
      chart_data: [],
      ROOTFONTFIZE: '',
      get_real_holder: false,
    };
  },
  computed: {
    tabKeys() {
      if (!this.chart_data.length) return [];
      return Object.keys(this.chart_data[0]).filter((n) => n !== 'index');
    },
    queryStr() {
      const rp_period = this.select11.default;
      const r_type = this.category_cascader_val_chart3.join('&r_type=');
      const codes = this.reit_code.join('&codes=');
      const res_type = this.select1.default;
      const relative = { 份额: 3, 亿元: 2, 绝对: 0, 相对: 1 }[this.select_2_default];
      const sel_codes = this.s_radio === '板块对比' ? '0' : '1';
      const get_real_holder = this.get_real_holder ? 1 : 0;
      if (this.s_radio === '板块对比') {
        return `sel_codes=${sel_codes}&rp_period=${rp_period}&res_type=${res_type}&relative=${relative}&r_type=&codes=&get_real_holder${get_real_holder}`;
      }
      return `sel_codes=${sel_codes}&rp_period=${rp_period}&res_type=${res_type}&relative=${relative}&r_type=${
        r_type || ''
      }&codes=${codes || ''}&get_real_holder${get_real_holder}`;
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
  },
  watch: {
    queryStr() {
      this.loading = true;
      this.debounceLoadingData();
    },
    currentTheme() {
      this.fnGetTheme();
      this.debounceRender();
    },
  },
  methods: {
    number2Pct,
    numberFix2,
    debounceLoadingData: debounce(function () {
      this.loadingData();
    }, 800),
    async loadPeriod() {
      const { data } = await this.$https.get(`/api/v2_5/rp_period_button?r_type=`);
      if (data.code !== 200) return this.$message.error(data.msg);
      this.chart_data = Object.freeze(data.data);
      if (!(data.data || []).length) return;
      this.select11 = {
        default: data.data[0],
        options: data.data.map((item) => ({ label: item, value: item })),
      };
    },
    formatterColumn(row, column, cellValue, index) {
      return number2Pct(cellValue);
    },
    debounceRender: debounce(function () {
      this.chartRender();
    }, 400),
    chartRender() {
      if (!this.chart_data.length) {
        this.echart_instance && this.echart_instance.clear();
        return;
      }
      if (!this.echart_instance) {
        this.echart_instance = this.$echarts.init(this.$refs.chart_1716424);
      }
      this.echart_instance.clear();

      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      const data = this.chart_data;
      const xLabel = Object.keys(data[0]).filter((k) => k !== 'index');

      const color_map = {
        券商资管: '#96dcf8',
        '银行/银行理财子': '#4ea72e',
        公募基金及基金子公司: '#46b1e1',
        不良资产管理: '#095f80',
        国资投资公司: '#0d3a4e',
        其他类型: '#46b1e1',
        产业资本: '#aeaeae',
        私募基金: '#9492ee',
        信托: '#1f8ec0',
        保险: '#0f9ed5',
        券商自营: '#0b76a0',
        原始权益人或关联方: '#5e5ce6',
        个人: '#5ae8ed',
      };

      const series = data.map((item) => {
        const { index, ...args } = item;
        return {
          name: index,
          data: Object.values(args),
          type: 'bar',
          stack: 'stack',
          itemStyle: {
            color: color_map[item.index],
          },
          // barWidth: 70,
        };
      });
      const dataSize = Object.keys(data[0]).length - 1;
      const options = {
        series,
        xAxis: {
          type: 'category',
          data: xLabel,
          axisLabel: {
            interval: 0,
            margin: OPTIONDATA.xAxis.axisLabel.margin,
            fontSize: OPTIONDATA.xAxis.axisLabel.fontSize,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
            rotate: dataSize > 40 ? 270 : dataSize > 12 ? 30 : 0,
          },
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: (value) => {
              if (this.select_2_default === '亿元' || this.select_2_default === '份额') {
                return value;
              }
              return numberFix2(value * 100) + '%';
            },
            fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
            color: OPTIONDATA.yAxis.axisLabel.color,
          },
          splitLine: OPTIONDATA.yAxis.splitLine,
          scale: true,
          max: (value) => {
            if (this.select_2_default === '相对') {
              return 1.000000001;
            }
            return null;
          },
        },
        legend: {
          itemWidth: 12,
          itemHeight: 12,
          right: 0,
          top: 'center',
          orient: 'vertical',
          textStyle: {
            color: OPTIONDATA.legend.textStyle.color,
            fontSize: this.ROOTFONTFIZE * (12 / 144),
          },
        },
        toolbox: {
          // 工具箱按钮
          right: 30,
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            const p = params[0].name;
            return (
              p +
              ' <br />' +
              params
                .map(({ marker, seriesName, value }) => {
                  const k = seriesName;
                  const v =
                    this.select_2_default === '亿元' || this.select_2_default === '份额'
                      ? numberFix2(value) + '亿'
                      : number2Pct(value);
                  return marker + k + `<span style="margin-left:10px">${v}</span>`;
                })
                .join('<br />')
            );
          },
        },
        grid: {
          top: this.ROOTFONTFIZE * (20 / 144),
          left: this.ROOTFONTFIZE * (10 / 144),
          right: this.ROOTFONTFIZE * (150 / 144),
          bottom: this.ROOTFONTFIZE * (20 / 144),
          containLabel: true,
        },
      };

      this.echart_instance.setOption(options);
      this.echart_instance.resize();
      this.chart_options = Object.freeze(options);
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
    },
    resize() {
      this.fnGetWidth();
      this.echart_instance && this.echart_instance.resize();
    },
    fnGetTheme() {
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    select2Change(v) {
      this.select_2_default = v;
    },
    fnCCascader_select_val_chart3(val) {
      if (!val.length) {
        this.$message.error('请选择类别');
        return;
      }
      this.category_cascader_val_chart3 = val;
    },
    fnSelect_select_val_chart1_codename(val) {
      val = val.filter((node) => {
        return node.includes('.');
      });

      this.reit_code = Object.freeze(val);
    },
    fnCSelect_chart1(v) {
      this.select1 = {
        ...this.select1,
        default: v,
      };
    },
    fnCSelect_chart11(v) {
      this.select11 = {
        ...this.select11,
        default: v,
      };
    },
    async loadingData() {
      const { data } = await this.$https.get(
        `/api/v2_5/fin_rp_type_holder_compare?${this.queryStr}`
      );
      setTimeout(() => {
        this.loading = false;
      }, 300);
      if (data.code !== 200) return this.$message.error(data.msg);
      this.chart_data = Object.freeze(data.data);
      if (!(data.data || []).length) return;

      if (this.s_radio !== '板块对比') {
        /* const json_fields = Object.keys(data.data[0]).reduce((p, c) => {
          p[c] = c;
          return p;
        }, {}); */
        const json_fields = Object.keys(data.data[0]).reduce((p, c) => {
          if (this.CODEobj[c]) {
            p[this.CODEobj[c]] = {
              callback: (v) => {
                return v[c];
              },
            };
          } else {
            p[c] = c;
          }
          return p;
        }, {});
        const item = { ...data.data[0] };
        Object.keys(item).forEach((k) => {
          if (k === 'index') {
            item[k] = '代码';
          } else {
            item[k] = k;
          }
        });
        const _data = [item, ...data.data];
        this.excel_info1 = Object.freeze({
          excel_data: _data,
          overviewName: `公募REITs - 不同板块细分投资人机构占比`,
          json_fields,
        });
        data.data = data.data.map((item) => {
          const { index, ...args } = item;
          const item_value = Object.keys(args).reduce((p, c) => {
            p[this.CODEobj[c]] = args[c];
            return p;
          }, {});
          return {
            index,
            ...item_value,
          };
        });
        this.chart_data = data.data;
      } else {
        const json_fields = Object.keys(data.data[0]).reduce((p, c) => {
          p[c] = c;
          return p;
        }, {});
        this.excel_info1 = Object.freeze({
          excel_data: data.data,
          overviewName: `公募REITs - 不同板块细分投资人机构占比`,
          json_fields,
        });
      }
      setTimeout(() => {
        this.debounceRender();
      }, 0);
    },
  },
  async mounted() {
    await this.loadPeriod();
    /*   this.reit_code = Object.freeze(
      this.reit_code_default
        .map((item) => {
          return item.find((n) => n.indexOf('.') >= 0);
        })
        .filter((item) => item)
    ); */
    /* if (this.s_radio === '板块对比') {
      this.loadingData();
    } */
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    this.echart_instance && this.echart_instance.dispose();
  },
};
</script>

<style scoped lang="less">
.icon-fangda {
  position: absolute;
  right: 8px;
  top: 138px;
}

/deep/.el-radio__input.is-checked + .el-radio__label {
  color: var(--chart_title);
}
/deep/.el-radio__label {
  color: var(--chart_title);
  font-weight: 400;
}
/deep/.el-radio {
  margin-right: 16px;
}

.chart-title {
  margin-top: 16px;
  color: var(--chart_title);
  font-weight: 700;
  font-size: 16px;
  text-align: center;
}

//fix 滚动条重叠部分背景颜色
/deep/.el-table__body-wrapper::-webkit-scrollbar-corner {
  background-color: transparent;
}
/deep/.items-center {
  align-items: center;
}
/deep/.relative {
  position: relative;
}
/deep/.flex {
  display: flex;
}

/* el-table start */

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */
</style>
